export const P00039RuptureAlimentationEnum = [
  { ref: 1, label: 'P00039.rupturealimentation.1' },
  { ref: 2, label: 'P00039.rupturealimentation.2' },
  { ref: 3, label: 'P00039.rupturealimentation.3' },
  { ref: 4, label: 'P00039.rupturealimentation.4' },
  { ref: 5, label: 'P00039.rupturealimentation.5' },
  { ref: 6, label: 'P00039.rupturealimentation.6' },
  { ref: 7, label: 'P00039.rupturealimentation.7' },
  { ref: 8, label: 'P00039.rupturealimentation.8' },
  { ref: 9, label: 'P00039.rupturealimentation.9' },
  { ref: 10, label: 'P00039.rupturealimentation.10' },
  { ref: 11, label: 'P00039.rupturealimentation.11' },
  { ref: 12, label: 'P00039.rupturealimentation.12' },
  { ref: 13, label: 'P00039.rupturealimentation.13' },
  { ref: 14, label: 'P00039.rupturealimentation.14' },
  { ref: 15, label: 'P00039.rupturealimentation.15' },
  { ref: 16, label: 'P00039.rupturealimentation.16' },
  { ref: 17, label: 'P00039.rupturealimentation.17' },
  { ref: 18, label: 'P00039.rupturealimentation.18' },
  { ref: 19, label: 'P00039.rupturealimentation.19' },
  { ref: 20, label: 'P00039.rupturealimentation.20' },
];
